type ToastKind = 'info' | 'win' | 'bad';

const HOLD_MS = 3200;
const MAX_VISIBLE = 3;

/** Transient notices. Anything a player must act on belongs in the gate, not here. */
export class Toasts {
  constructor(private readonly host: HTMLElement) {}

  show(message: string, kind: ToastKind = 'info'): void {
    const el = document.createElement('div');
    el.className = kind === 'info' ? 'toast' : `toast ${kind}`;
    el.textContent = message;
    this.host.appendChild(el);

    while (this.host.children.length > MAX_VISIBLE) {
      this.host.firstElementChild?.remove();
    }

    window.setTimeout(() => {
      el.style.transition = 'opacity .25s';
      el.style.opacity = '0';
      window.setTimeout(() => el.remove(), 260);
    }, HOLD_MS);
  }
}
